/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Expand Collapse Button
 *
 * @file ExpandCollapseButton.jsx
 * @author Gladson Samuel S
 */

import React from 'react';
import PropTypes from 'prop-types';
import { GlobalStyles } from '@mui/material';
import {
  expandCollapseGlobalStyles,
  ExpandCollapseButtonContainer,
  StyledTooltip
} from './styles/ExpandCollapseButtonStyles';
import ExpandedHoverIcon from '../../icons/ExpandedHoverIcon';
import ExpandedBack from '../../icons/ExpandedBack';
import CommonUtils from '../../utils/CommonUtils';

const ExpandCollapseButton = ({
  isMenuOpen,
  onClick,
  isDisabled,
  tooltipTitle
}) => (
  <>
    <GlobalStyles styles={expandCollapseGlobalStyles} />
    <StyledTooltip
      title={tooltipTitle || CommonUtils.getExpandCollapseTooltipText(isMenuOpen)}
      placement="right"
      popperClassName={isMenuOpen ? '' : 'expand-collapse-button-collapsed-popper'}
      arrow
      enterDelay={500}
      enterNextDelay={500}
    >
      <ExpandCollapseButtonContainer
        onClick={onClick}
        className="expand-collapse-button"
        disableRipple
        aria-label={isMenuOpen ? 'Collapse Menu' : 'Expand Menu'}
        disabled={isDisabled}
      >
        {isMenuOpen
          ? <ExpandedHoverIcon />
          : <ExpandedBack />
    }
      </ExpandCollapseButtonContainer>
    </StyledTooltip>
  </>
);

ExpandCollapseButton.defaultProps = {
  isMenuOpen: false,
  onClick: () => {},
  isDisabled: false,
  tooltipTitle: ''
};

ExpandCollapseButton.propTypes = {
  isMenuOpen: PropTypes.bool,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  tooltipTitle: PropTypes.string
};

export default ExpandCollapseButton;
